export default __webpack_public_path__ + "static/cafe_36082-1781a8ad2671eda4ad22a74eccad949c.png";